import React from 'react';
import PropTypes from 'prop-types';

// Utils
import bemify from 'utils/bemify';

// Components
import Button from 'components/button';
import Checkbox from 'components/checkbox';

// Styles
import stylesModule from './styles.module.scss';


const styles = bemify(stylesModule);

const TagButton = ({
  checked = false,
  className = null,
  href = null,
  icon = null,
  id = null,
  isCheckbox = false,
  label,
  onCheckboxChange = () => {},
  onClick = () => {}
}) => {
  const handleCheckboxWrapperKeyDown = (event) => {
    // Perform action only if spacebar is pressed
    if (event.keyCode === 32) {
      event.preventDefault();

      onCheckboxChange(label);
    }
  };

  const handleCheckboxWrapperClick = () => {
    onCheckboxChange(label);
  };

  return (
    isCheckbox ?
      (
        <div
          className={`${styles.tagButton} ${styles.tagButton__checkboxWrapper}${className ? ` ${className}` : ''}`}
          role="button"
          tabIndex={-1}
          onClick={handleCheckboxWrapperClick}
          onKeyDown={handleCheckboxWrapperKeyDown}
        >
          <Checkbox
            checked={checked}
            className={styles.tagButton__checkbox}
            icon={icon}
            id={id}
            label={label}
          />
        </div>
      ) :
      (
        <Button
          className={`${styles.tagButton}${className ? ` ${className}` : ''}`}
          href={href}
          icon={icon}
          iconClassName={styles.tagButton__icon}
          iconPosition="left"
          text={label}
          textWeight="regular"
          theme="grey"
          onClick={onClick}
        />
      )
  );
};

TagButton.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isCheckbox: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onCheckboxChange: PropTypes.func,
  onClick: PropTypes.func
};

export default TagButton;
